import {Link} from 'react-router-dom';
import supplyLogo from "../../../../../common/assets/supply-logo.png";
import {MainMenuWithContext} from '../contexts/MainMenuContext';
import UrlsService from '../../../../../common/router/services/urlsService.mdl';
import UserMenu from '../components/user-menu/UserMenu';
import NotificationPanel from "../../../../user-notifications/components/notification-panel/NotificationPanel";
import ThemeSwitch from '../components/theme-switch/ThemeSwitch';
import theme from './theme.module.scss';
import ChangeLogsLinks from '../../../../change-logs/common/links/ChangeLogsLinks';
import ChartsLinks from '../../../../charts/links/ChartsLinks';
import DashboardsLinks from '../../../../dashboards/links/DashboardsLinks';
import ReportingLinks from '../../../../reporting/common/links/ReportsLinks';
import ScheduleReportsLinks from '../../../../schedule-reports/links/ScheduleReportsLinks';
import TimePresetsSelect from "../components/time-presets-select/TimePresetsSelect";
import {observer} from "mobx-react";
import AppsMenu from '../components/apps-menu/AppsMenu';

function MainMenu(): React.JSX.Element {

    return (
        <MainMenuWithContext>
            <div className={theme.menuContainer}>
                <div className={theme.navigation}>
                    <div className={theme.logo}>
                        <Link to={UrlsService.dashboards()}>
                            <img src={supplyLogo} width={181} height={66} alt="Perion Supply"/>
                        </Link>
                    </div>
                    <DashboardsLinks/>
                    <ChartsLinks/>
                    <ReportingLinks/>
                    <ScheduleReportsLinks/>
                    <ChangeLogsLinks/>
                </div>
                <div className={theme.utilities}>
                    <TimePresetsSelect/>
                    <ThemeSwitch/>
                    <NotificationPanel/>
                    <AppsMenu/>
                    <UserMenu/>
                </div>
            </div>
        </MainMenuWithContext>
    );
}

export default observer(MainMenu);
